module.exports = __webpack_public_path__ + "static/media/IFTA-12-22.f3420ffe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IFTA-12-22.webp
// module id = 129
// module chunks = 0